const footerNav = [
  { label: "实时热搜", href: "#trending" },
  { label: "绯闻频道", href: "#gossip" },
  { label: "深度复盘", href: "#feature" },
  { label: "绯闻全记录", href: "#timeline" },
  { label: "关于瓜田", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200/80 border-t border-background-300">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <a href="#home" className="inline-flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-600 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-empathize-line"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-extrabold text-foreground-950">绯闻瓜田</span>
                <span className="text-[10px] tracking-[0.2em] text-foreground-500">MELON DAILY</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-sm">
              专注娱乐圈明星绯闻与情感动态的八卦资讯站。核实来源、梳理时间线、保留多元视角，让你第一手掌握偶像情感走向。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              商务合作 / 瓜料投稿：melondaily@example.com
            </p>
          </div>

          <nav className="md:col-span-4 flex flex-col" aria-label="页脚导航">
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-3">快速导航</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {footerNav.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                    <i className="ri-arrow-right-s-line text-primary-400"></i> {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-3">内容原则</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-600">
              <li className="inline-flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-600"></i> 来源可查证
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-scales-3-line text-accent-600"></i> 客观克制表达
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-timer-flash-line text-accent-600"></i> 动态实时跟进
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-foreground-500">
              <i className="ri-windy-line text-lg"></i>
              <span className="text-xs">吃瓜有度，理性围观</span>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} 绯闻瓜田 Melon Daily · 内容基于公开信息整理，仅供参考。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-empathize-line text-primary-500"></i> 做一个清醒又有温度的吃瓜人
          </p>
        </div>
      </div>
    </footer>
  );
}